const handleBackInStock = (variant, productData) => {
  const buttonElsBis = document.querySelectorAll('[data-bis-submit]');
  const ukPhoneInput = document.querySelector('[data-uk-phone]');
  const ukPhoneInputWrapper = document.querySelector('[data-uk-phone-wrapper]');
  const ukPhoneLabel = document.querySelector('[data-uk-phone-label]');

  // Only show the UK phone input if the user is in the UK
  if (window.Shopify.country === 'GB' && ukPhoneInput) {
    ukPhoneInput.style.display = 'block';
    ukPhoneLabel.style.display = 'flex';
    ukPhoneInputWrapper.style.display = 'block';
    ukPhoneInput.value = '+44';

    ukPhoneInput.addEventListener('keyup', function () {
      // Remove the first character if it's 0 and prepend '+44'
      if (this.value.startsWith('0')) {
        this.value = '+44' + this.value.slice(1);
      } else if (this.value.startsWith('+44 0')) {
        this.value = '+44' + this.value.slice(5);
      }
      // Add '+44' if it's not already present and doesn't start with '44'
      else if (!this.value.startsWith('+44') && !this.value.startsWith('44')) {
        this.value = '+44' + this.value;
      }
    });
  }
  // If non-UK, clear the phone input value
  else {
    ukPhoneInput.value = '';
  }

  const buttonElsComingSoon = document.querySelectorAll('[data-coming-soon-submit]');
  if (buttonElsComingSoon.length > 0) {
    buttonElsComingSoon.forEach(buttonEl => {
      buttonEl.addEventListener('click', () => {
        const wrapper = buttonEl.closest('[data-back-in-stock]');
        const notifyMessage = wrapper.querySelector('[data-notify-message]');
        const form = wrapper.querySelector('[data-coming-soon-form]');
        const emailInput = wrapper.querySelector('[data-email-input]');
        const ukPhoneInput = document.querySelector('[data-uk-phone]');

        const validateEmail = () => {
          const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

          let hasEmail = false;
          let hasPhone = false;
          const timestamp = parseInt(Date.now() / 1000);

          if (ukPhoneInput && ukPhoneInput.value !== '+44') {
            hasPhone = true;

            window['exponea'].identify(
              { phone_id: ukPhoneInput.value },
              {
                phone: ukPhoneInput.value
              }
            );

            // legitimate interest implied consent
            // requested by BR/NFD
            // info: https://neverfullydressedtalk.slack.com/archives/C046CULMQCR/p1680609663724939
            window['exponea'].track('consent', {
              action: 'accept',
              category: 'whatsapp',
              // eslint-disable-next-line camelcase
              valid_until: 'unlimited',
              placement: 'Coming Soon',
              timestamp: timestamp
            });
          }

          if (emailInput.value.match(regex)) {
            hasEmail = true;

            window['exponea'].identify(
              { email_id: emailInput.value },
              {
                email: emailInput.value
              }
            );

            // legitimate interest implied consent
            // requested by BR/NFD
            // info: https://neverfullydressedtalk.slack.com/archives/C046CULMQCR/p1680609663724939
            window['exponea'].track('consent', {
              action: 'accept',
              category: 'email',
              // eslint-disable-next-line camelcase
              valid_until: 'unlimited',
              placement: 'Coming Soon',
              timestamp: timestamp
            });
          }

          if (hasEmail === true || hasPhone === true) {
            if (hasEmail === true) {
              form.classList.add('hide');
              notifyMessage.textContent = notifyMessage.dataset.correctMessage;
              notifyMessage.classList.remove('hide');
            } else if (!emailInput.value.match(regex) && !hasPhone) {
              notifyMessage.textContent = notifyMessage.dataset.incorrectEmail;
              notifyMessage.classList.remove('hide');
            }

            window['exponea'].track('coming_soon', {
              status: 'created',
              // eslint-disable-next-line camelcase
              product_id: productData.id,
              // eslint-disable-next-line camelcase
              product_title: productData.title,
              // eslint-disable-next-line camelcase
              variant_id: variant.id,
              // eslint-disable-next-line camelcase
              variant_title: variant.name
            });
          }
        };
        validateEmail();
      });
    });
  } else {
    buttonElsBis.forEach(buttonEl => {
      buttonEl.addEventListener('click', () => {
        const bisWrapper = buttonEl.closest('[data-back-in-stock]');
        const notifyMessage = bisWrapper.querySelector('[data-notify-message]');
        const form = bisWrapper.querySelector('[data-bis-form]');
        const emailInput = bisWrapper.querySelector('[data-email-input]');
        const ukPhoneInput = document.querySelector('[data-uk-phone]');

        const validateEmail = () => {
          const regex =
            /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

          let hasEmail = false;
          let hasPhone = false;
          const timestamp = parseInt(Date.now() / 1000);

          if (ukPhoneInput && ukPhoneInput.value !== '+44') {
            hasPhone = true;

            window['exponea'].identify(
              { phone_id: ukPhoneInput.value },
              {
                phone: ukPhoneInput.value
              }
            );

            // legitimate interest implied consent
            // requested by BR/NFD
            // info: https://neverfullydressedtalk.slack.com/archives/C046CULMQCR/p1680609663724939
            window['exponea'].track('consent', {
              action: 'accept',
              category: 'whatsapp',
              // eslint-disable-next-line camelcase
              valid_until: 'unlimited',
              placement: 'Back In Stock',
              timestamp: timestamp
            });
          }

          if (emailInput.value.match(regex)) {
            hasEmail = true;

            window['exponea'].identify(
              { email_id: emailInput.value },
              {
                email: emailInput.value
              }
            );

            // legitimate interest implied consent
            // requested by BR/NFD
            // info: https://neverfullydressedtalk.slack.com/archives/C046CULMQCR/p1680609663724939
            window['exponea'].track('consent', {
              action: 'accept',
              category: 'email',
              // eslint-disable-next-line camelcase
              valid_until: 'unlimited',
              placement: 'Back In Stock',
              timestamp: timestamp
            });
          }

          if (hasEmail === true || hasPhone === true) {
            if (hasEmail === true) {
              form.classList.add('hide');
              notifyMessage.textContent = notifyMessage.dataset.correctMessage;
              notifyMessage.classList.remove('hide');
            } else if (!emailInput.value.match(regex) && !hasPhone) {
              notifyMessage.textContent = notifyMessage.dataset.incorrectEmail;
              notifyMessage.classList.remove('hide');
            } else if (!emailInput.value.match(regex) && hasPhone) {
              form.classList.add('hide');
              notifyMessage.textContent = notifyMessage.dataset.correctMessage;
              notifyMessage.classList.remove('hide');
            }

            window['exponea'].track('watchdog_restock_initiated', {
              status: 'created',
              // eslint-disable-next-line camelcase
              product_id: productData.id,
              // eslint-disable-next-line camelcase
              product_title: productData.title,
              // eslint-disable-next-line camelcase
              variant_id: variant.id,
              // eslint-disable-next-line camelcase
              variant_title: variant.name
            });
          }
        };
        validateEmail();
      });
    });
  }
};

export default handleBackInStock;
